import React from "react";
import {
    Card,
    CardContent,
    Box,
    Typography,
    Skeleton,
    CardHeader,
} from "@mui/material";
const BlankCard = () => {
    return (
        <Card className="card" data-cy="card_blank">
            <CardHeader
                avatar={
                    <Skeleton
                        animation="wave"
                        variant="circular"
                        width={52}
                        height={52}
                        sx={{ marginRight: "8px" }}
                    />
                }
                title={
                    <Typography variant="h2">
                        <Skeleton animation="wave" width="40%" />
                    </Typography>
                }
                subheader={
                    <Typography variant="h3">
                        <Skeleton animation="wave" width="20%" />
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <Typography variant="body1">
                        <Skeleton
                            sx={{ height: 190 }}
                            animation="wave"
                            variant="rectangular"
                        />
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default BlankCard;
